var $f2b90225f3681156$exports = {};
$f2b90225f3681156$exports = {
    "invalidSelection": (args, formatter)=>`Ausgew\xe4hlte(s) ${formatter.plural(args.selectedCount, {
            one: `Datum`,
            other: `Daten`
        })} nicht verf\xfcgbar.`
};


export {$f2b90225f3681156$exports as default};
//# sourceMappingURL=de-DE.mjs.map
